import React, { useContext } from 'react'
import { map, isBlank } from 'lodash'
import { Accordion, AccordionContext, ListGroup, useAccordionButton } from 'react-bootstrap'
import Avatar from './Avatar'
import Icon from 'UI/FontAwesomeIcon'

const CustomToggle = ({ eventKey, callback, children }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey),
  )

  return (
    <h6 className='text-secondary' style={{ fontSize: 'clamp(14px, 16px, 20px)' }} onClick={decoratedOnClick}>
      <div className='d-flex justify-content-between'>
        <span>{children}</span>

        <span className='align-self-end'><Icon icon={(activeEventKey === eventKey) ? 'chevron-up' : 'chevron-down'} /></span>
      </div>
    </h6>
  )
}

const Expanded = ({ currentUser, logOutPath, avatarUrl, menuItems }) => {
  const menuItemListItems = map(menuItems, ({ items = [], name, icon, titleHref }, index) => {
    if (isBlank(items)) {
      return (
        <ListGroup.Item className='pl-0' key={index}>
          <h6 className='text-secondary' style={{ fontSize: 'clamp(14px, 16px, 20px)' }}>
            <i className={`fad fa-${icon}`} style={{ paddingRight: '10px' }}></i>

            <a {...{ href: titleHref, className: 'text-secondary' }} style={{ fontSize: 'clamp(14px, 16px, 20px)' }} >
              {name}
            </a>
          </h6>
        </ListGroup.Item>
      )
    }

    return (
      <ListGroup.Item className='pl-0' key={index}>
        <CustomToggle key={name} variant="link" eventKey={name} className='text-secondary' style={{ fontSize: 'clamp(14px, 16px, 20px)' }}>
          <i className={`fad fa-${icon} mr-1`} style={{ marginRight: '5px' }}></i> {name}
        </CustomToggle>

        <Accordion.Collapse className='sidebar__menu-item' eventKey={name}>
          <ul className='d-flex flex-column m-0 pl-2 pr-2 list-group list-group-flush'>
            {map(items, ({ text, href }) => (
              <li key={text} className='list-group-item pl-0'>
                <a {...{ href }} >{text}</a>
              </li>
            ))}
          </ul>
        </Accordion.Collapse>
      </ListGroup.Item>
    )
  })

  return (
    <aside className="sidebar jumbotron">
      <div className='sidebar__content'>
        <Accordion flush>
          <ListGroup variant="flush">
            {menuItemListItems}
          </ListGroup>
        </Accordion>
      </div>

      <div>
        <Avatar {...{ menuPlacement: 'top', currentUser, logOutPath, avatarUrl }} />

        {/* <div>
          <i className="fal fa-arrow-to-left"></i>
        </div> */}
      </div>
    </aside>
  )
}

export default Expanded
